module.exports = __webpack_public_path__ + "img/cover-minigame-bg.1c580a44.png";